// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"d2d963ed","70":"ed285b9a","75":"79d8e596","110":"9dc071cd","238":"ebcf339b","239":"375dae3a","276":"0947bfb3","353":"700fa49f","389":"38958068","448":"bb335ff8","612":"4d7d8c22","743":"afe9b3e8","807":"80b69182","818":"7fa951af"}[chunkId] + ".chunk.js";
};